import { MenuItem } from "@blueprintjs/core"
import { ItemRenderer, Suggest } from "@blueprintjs/select"
import { useState } from "react"
import useCompanies from "../hooks/useCompanies"
import { TradingCompany } from "../pages/Config/types"

interface CompanySuggestProps {
  selectedCompany: TradingCompany | null
  onCompanySelect: (company: TradingCompany) => void
  placeholder: string
}

/**
 * Reusable Suggest component to select a company from
 * the companies list. Only fetches when user starts typing.
 */
const CompanySuggest = ({ selectedCompany, onCompanySelect, placeholder }: CompanySuggestProps) => {
  const [query, setQuery] = useState("")
  const { companies } = useCompanies(query)

  const renderCompany: ItemRenderer<TradingCompany> = (company, { handleClick, modifiers }) => {
    return (
      <MenuItem
        active={modifiers.active}
        key={company.id}
        onClick={handleClick}
        text={company.name}
        label={company.main_instrument_ticker ?? undefined}
      />
    )
  }

  const noResults = (
    <MenuItem
      active={false}
      disabled={true}
      icon="zoom-out"
      text={query.length === 0 ? "Type to search companies" : "No Companies found"}
    />
  )

  return (
    <Suggest<TradingCompany>
      items={companies ?? []}
      inputValueRenderer={(company: TradingCompany) => company.name}
      itemRenderer={renderCompany}
      onItemSelect={onCompanySelect}
      onQueryChange={setQuery}
      noResults={noResults}
      fill={true}
      inputProps={{ placeholder }}
      selectedItem={selectedCompany}
      resetOnSelect={true}
    />
  )
}

export default CompanySuggest
